import React from 'react'
import { Card, CardContent, TextField, Typography } from '@material-ui/core'
import ParamsEditor from './ParamsEditor'


const PlayPattern = (props: {
	playPattern: any,
	onChange: (playPattern: any) => void,
}) => {

	const {
		playPattern,
		onChange
	} = props

	return (
		<Card style={{ marginLeft: 24, minWidth: 320, maxWidth: 320, height: 289 }}>
			<CardContent>

				<Typography variant='h4'>Play pattern</Typography>

				{/* <Typography variant='h5'>Clips</Typography> */}

				<ParamsEditor
					// @ts-ignore
					name='Play pattern'
					// @ts-ignore
					value={playPattern}
					onChange={(playPattern: any) => onChange(playPattern)}
					height={200}
				/>

			</CardContent>
		</Card>
	)
}

export default PlayPattern
